// MUI
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';

const StyledList = styled(List)({
  width: '100%',
});

const Index = ({ children, ...rest }) => {
  return <StyledList {...rest}>{children}</StyledList>;
};

export default Index;
